import {DqButtonStateType} from 'module/DqButton/reducer/DqButtonReducer';

export const selDqButtonsByLocation = (state: DqButtonStateType) => state.DqButton.byLocation
export const selDqButtonLoading = (state: DqButtonStateType) => state.DqButton.transient.loading
export const selDqButtonErrorById = (state: DqButtonStateType) => state.DqButton.transient.error